import styled from 'styled-components';

export default styled.div`
  padding: 1rem;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr max-content;
  border-bottom: 1px solid ${(p) => p.theme.colors.primaryDarkGray};
`;
